<!--
    AssetManagerMediaItem

    DESCRIPTION
    A single media item rendered by the AssetManagerMedia component
-->

<template>
    <div class="col-span-1 flex flex-col divide-y divide-gray-200 rounded-lg bg-white overflow-hidden shadow">
        <!--<div class="aspect-w-3 aspect-h-4 bg-gray-200 group-hover:opacity-75 sm:aspect-none sm:h-70">-->
        <div class="bg-gray-200 sm:h-64 relative z-10">
            <img :src="media.url" alt="Eight shirts arranged on table in black, olive, grey, blue, white, red, mustard, and green." class="h-full w-full object-cover object-center sm:h-full sm:w-full relative z-10">
            <button v-on:click="makePrimary" v-if="media.type == 'image' && !form.media.fields.primary.value" type="button" class="absolute top-4 right-4 z-20">
                <StarSolidIcon class="text-white h-3 w-3 opacity-75" />
            </button>
            <span v-if="media.type == 'image' && form.media.fields.primary.value" class="absolute top-4 right-4 z-20 inline-flex items-center rounded-full bg-white bg-opacity-25 px-3 py-0.5 text-xs font-medium text-white">
                Primary Image
                <StarSolidIcon class="text-white ml-2 h-3 w-3" />
            </span>
        </div>

        <div class="flex flex-1 flex-col space-y-2 p-4">

            <div class="flex justify-between">
                <h3 class="text-sm font-medium text-gray-900" v-html="media.file_name"></h3>
                <span class="inline-flex items-center rounded-full bg-blue-100 px-2.5 py-0.5 text-xs font-medium text-blue-800" v-on:click="state.settings_modal_active = true">{{ media.visibility }}</span>
            </div>

            <div>
                <p v-if="media.caption" class="text-sm text-gray-500" v-html="media.caption"></p>
                <button v-else v-on:click="state.settings_modal_active = true" class="text-sm text-blue-500">Add caption</button>
            </div>

            <!--
            <div class="flex items-center mb-2">
                Enabled: "bg-indigo-600", Not Enabled: "bg-gray-200"
                <button type="button" class="bg-gray-200 relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" role="switch" aria-checked="false" aria-labelledby="annual-billing-label">
                    Enabled: "translate-x-5", Not Enabled: "translate-x-0"
                    <span aria-hidden="true" class="translate-x-0 pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
                </button>
                <span class="ml-3" id="annual-billing-label">
                    <span class="text-sm font-medium text-gray-900">Primary Image</span>
                </span>
            </div>
            -->
        </div>
        <div>
            <div class="-mt-px flex divide-x divide-gray-200">
                <div class="flex w-0 flex-1">
                    <button v-on:click="state.settings_modal_active = true" class="relative -mr-px inline-flex w-0 flex-1 items-center justify-center rounded-bl-lg border border-transparent py-4 text-sm font-medium text-gray-500 hover:text-gray-700">
                        <SettingsIconFill class="h-4 w-4" />
                        <span class="ml-3">Settings</span>
                    </button>
                </div>
                <div class="-ml-px flex w-0 flex-1">
                    <button v-on:click="state.delete_modal_active = true" class="relative inline-flex w-0 flex-1 items-center justify-center rounded-br-lg border border-transparent py-4 text-sm font-medium text-gray-500 hover:text-gray-700">
                        <TrashIconFill class="h-4 w-4" />
                        <span class="ml-3">Delete</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <Modal v-on:close="state.delete_modal_active = false" :active="state.delete_modal_active" size="sm">
        <div>
            <div class="mt-3 text-center sm:mt-5">
                <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">Confirm Delete</DialogTitle>
                <div class="my-2">
                    <p class="text-sm text-gray-500">Are you sure you want to delete this file?</p>
                </div>
            </div>
        </div>
        <div class="mt-5 sm:mt-6">
            <Button v-on:click="deleteMedia()" type="button" color="red" class="mb-2">
                <span v-if="!state.delete_in_progress">Delete File</span>
                <LoadingIcon v-if="state.delete_in_progress" class="-ml-1 mr-3 h-5 w-5 animate-reverse-spin" />
            </Button>
            <Button v-if="true" type="button" color="blue-outline" v-on:click="state.delete_modal_active = false" :disabled="state.delete_in_progress">Cancel</Button>
        </div>    
    </Modal>

    <Modal v-on:close="state.settings_modal_active = false" :active="state.settings_modal_active" size="lg">
        <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">File Settings</DialogTitle>
        <Message :active="state.save_error" :heading="state.save_error_message" type="error" class="mt-4" />
        <div class="mt-5 sm:mt-6">
            <FormField v-for="(field, key) in form.media.fields" :key="key" :field="field" :namespace="`edit_media_${media.id}`" :name="key" class="mb-4" />
        </div>
        <div class="mt-5 sm:mt-6">
            <Button v-on:click="updateMedia()" type="button" color="blue" class="mb-2 sm:mb-0 sm:mr-2" width="auto">
                <span v-if="!state.settings_save_in_progress">Save</span>
                <LoadingIcon v-if="state.settings_save_in_progress" class="-ml-1 mr-3 h-5 w-5 animate-reverse-spin" />
            </Button>
            <Button v-if="true" type="button" width="auto" color="blue-outline" v-on:click="state.settings_modal_active = false" :disabled="state.settings_save_in_progress">Cancel</Button>
        </div> 
    </Modal>
</template>

<script>
import TrashIconFill from '@ico/TrashIconFill.vue'
import SettingsIconFill from '@ico/SettingsIconFill.vue'
import LoadingIcon from '@ico/LoadingIcon.vue'

//import StarOutlineIcon from '@ico/StarOutlineIcon.vue'
import StarSolidIcon from '@ico/StarSolidIcon.vue'

import * as AssetService from '@ser/asset'
import { useAssetStore } from '@sto/asset.store'
import { isValid, getPayload } from '@lib/helpers'
import { reactive, watch } from 'vue'

export default {
    components: {
        TrashIconFill,
        SettingsIconFill,
        LoadingIcon,
        //StarOutlineIcon,
        StarSolidIcon
    },
    props: ['asset_id', 'media'],
    setup(props, {emit}) {

        const ASSET_STORE = useAssetStore()
        
        const state = reactive({
            save_error: false,
            save_error_message: '',
            delete_modal_active: false,
            delete_in_progress: false,
            settings_modal_active: false,
            settings_save_in_progress: false
        })

        const form = reactive({
            media: {
                fields: {
                    caption: {
                        active: true,
                        label: 'Caption',
                        type: 'textarea',
                        value: props.media?.caption || '',
                        stored_value: props.media?.caption || '',
                        required: false,
                        pristine: props.media?.caption ? false : true,
                        valid: true,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: true,
                        disabled: false
                    },
                    visibility: {
                        active: true,
                        label: 'File visibility',
                        type: 'select',
                        value: props.media?.visibility || 'public',
                        stored_value: props.media?.visibility || '',
                        options: [
                            {
                                value: 'public',
                                label: 'Public: anyone can see the file'
                            },
                            {
                                value: 'protected',
                                label: 'Protected: only the seller and auctioneer can see the file'
                            },
                            {
                                value: 'private',
                                label: 'Private: only your account'
                            }
                        ],
                        required: false,
                        pristine: props.media?.visibility ? false : true,
                        valid: true,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: true,
                        disabled: false
                    },
                    primary: {
                        active: props.media.type == 'image',
                        label: 'Primary image',
                        type: 'toggle',
                        value: props.media?.primary || false,
                        stored_value: props.media?.caption || false,
                        required: false,
                        pristine: props.media?.caption ? false : true,
                        valid: true,
                        message: '',
                        validation: [],
                        notes: '',
                        editable: true,
                        disabled: false
                    },
                }
            }
        })

        // delete_modal_active: false,
        // delete_in_progress: false,

        const deleteMedia = async () => {

            state.delete_in_progress = true

            try {
                await AssetService.deleteMedia(props.media.id, props.asset_id)
                // insruct the parent to refresh the data (maintin a single source of truth for data)
                emit('refresh')

                state.delete_modal_active = false
                state.delete_in_progress = false

            } catch (error) {
                console.error('AssetService.deleteMedia error', error)
                state.delete_in_progress = false
            }
        }

        const updateMedia = async () => {

            // clear existing errors
            state.save_error_message = ''
            state.save_error = false

            state.settings_save_in_progress = true

            const payload = getPayload(form.media.fields)

            try {
                await AssetService.updateMedia(props.media.id, props.asset_id, payload)
                // insruct the parent to refresh the data (maintin a single source of truth for data)
                emit('refresh')

                state.settings_modal_active = false
                state.settings_save_in_progress = false

            } catch (error) {
                console.error('AssetService.updateMedia error', error)
                state.settings_save_in_progress = false
                state.save_error_message = 'Sorry, there was an error saving your changes'
                state.save_error = true
            }
        }

        const makePrimary = async () => {
            form.media.fields.primary.value = true
            await AssetService.updateMedia(props.media.id, props.asset_id, { primary: true })
            emit('refresh')
        }

        watch(
            () => props.media?.primary,
            (new_value, old_value) => {
                form.media.fields.primary.value = new_value ? true : false
            }
        )

        watch(
            () => form.media.fields.primary.value,
            (new_value, old_value) => {
                // if this is the primary image, it must be public
                if (new_value) form.media.fields.visibility.value = 'public'
            }
        )

        watch(
            () => form.media.fields.visibility.value,
            (new_value, old_value) => {
                // if this is the primary image, it must be public
                if (new_value != 'public' && form.media.fields.primary.value) form.media.fields.primary.value = false
            }
        )

        return {
            state,
            form,
            deleteMedia,
            updateMedia,
            makePrimary
        }
    },
}
</script>